import { TextLink } from '@lastbrand/web-ui/text-link'
import { css } from '@lastbrand/web-ui-styled-system/css'
import React, { ReactNode } from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import { useZipCodeEditModal } from '@src/quince-site-common/src/hooks/zipcode'

import type { SystemStyleObject } from '@lastbrand/web-ui-styled-system/types'

const zipLinkCss = css.raw({
  display: 'inline',
  font: 'inherit',
  color: 'inherit',
  // STRFRNT-16892: browsers compute `display: inline` on a <button> as inline-block, so the
  // TextLink `md` size variant's `paddingY: space-4` (the default size; it overrides the base's
  // space-2) inflates this link's box to line-height + 8px, growing the whole text line to 28px
  // and dropping the text's visual center below the check icon's (which centers on 1lh = 20px).
  // The negative block margin cancels the padding's line-box contribution (measured: row back to
  // 20px) while keeping the 28px click target. Sized to the md variant — revisit if the TextLink
  // size ever changes here.
  marginBlock: '-space-4',
})

export interface ZipCodeButtonDSProps {
  children: ReactNode
  /** Extra DS style object merged onto the base underlined zip-link styling. */
  cssOverride?: SystemStyleObject
}

/**
 * DS twin of the legacy ZipCodeButton. Renders a web-ui TextLink styled as the
 * underlined zip trigger; clicking opens the zip-code edit modal via the shared
 * useZipCodeEditModal hook (verbatim, not reimplemented).
 */
export function ZipCodeButtonDS({ children, cssOverride }: ZipCodeButtonDSProps) {
  const { openZipcodeModal } = useZipCodeEditModal()

  return (
    <TextLink
      type="button"
      data-testid={TEST_LOCATORS.ZIP_CODE.BUTTON}
      css={{ ...zipLinkCss, ...(cssOverride ?? {}) }}
      onClick={() => {
        openZipcodeModal(true)
      }}
    >
      {children}
    </TextLink>
  )
}

export default ZipCodeButtonDS
